<template>
    <slot></slot>
    <div>
        <v-dialog v-model="show" :max-width="options.width" :persistent="options.persistent">
            <v-card>
                <v-card-title class="px-6 mt-3">{{ title }}</v-card-title>
                <template v-if="!!content">
                    <v-card-text v-for="(c, idx) of content.split('\n')" :key="`content-${idx}`">{{ c }}</v-card-text>
                </template>
                <template v-if="options.showFeedback">
                    <v-card-subtitle class="px-6 mt-3">Feedback</v-card-subtitle>
                    <v-textarea v-model="feedback" class="px-6 mt-3"></v-textarea>
                </template>
                <v-card-actions class="pt-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn v-show="!!options.showCancel" variant="text" class="text-disabled" @click="cancel">Cancel</v-btn>
                    <v-btn color="primary" variant="text" @click="agree">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script lang="ts" setup>
import { CreateConfirmDialogKey, CreateFeedbackDialogKey } from '~/composables/useConfirmDialog';
import type { CreateConfirmDialogOptions } from '~/composables/useConfirmDialog';

const isOpen = ref(false);
let resolveFunction = (_val: boolean) => {};
let resolveFeedbackFunction = (_val: { confirmed: boolean; feedback: string }) => {};
const content = ref('');
const title = ref('');
const feedback = ref('');
const options = ref<CreateConfirmDialogOptions>({
    width: 500,
    showCancel: true,
    persistent: false,
    showFeedback: false,
});

const show = computed({
    get() {
        return isOpen.value;
    },
    set(value) {
        isOpen.value = value;
        if (value === false) {
            cancel();
        }
    },
});

function createConfirmDialog(titleParam: string, contentParam: string, optionsParam: CreateConfirmDialogOptions = {}) {
    isOpen.value = true;
    title.value = titleParam;
    content.value = contentParam;
    options.value = Object.assign(options.value, optionsParam);
    return new Promise<boolean>((resolve) => {
        resolveFunction = resolve;
    });
}

function createFeedbackDialog(titleParam: string, contentParam: string, optionsParam: CreateConfirmDialogOptions = {}) {
    isOpen.value = true;
    title.value = titleParam;
    content.value = contentParam;
    options.value = Object.assign(options.value, optionsParam);
    return new Promise<{ confirmed: boolean; feedback: string }>((resolve) => {
        resolveFeedbackFunction = resolve;
    });
}

provide(CreateConfirmDialogKey, createConfirmDialog);
provide(CreateFeedbackDialogKey, createFeedbackDialog);

const agree = () => {
    resolveFunction(true);
    resolveFeedbackFunction({ confirmed: true, feedback: feedback.value });
    isOpen.value = false;
};

const cancel = () => {
    resolveFunction(false);
    resolveFeedbackFunction({ confirmed: false, feedback: feedback.value });
    isOpen.value = false;
};
</script>
